import { createContext, useContext } from 'react'

const TextContext = createContext<boolean>(false)

export const TextProvider = TextContext.Provider

export const useTextContext = () => useContext(TextContext)
